import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { EyeOffIcon, DollarSignIcon } from 'lucide-react';
export function OpeningHookSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="relative w-full py-24 md:py-32 px-4 bg-bg-secondary" data-id="element-202">
      <div className="max-w-5xl mx-auto" data-id="element-203">
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.8
      }} className="grid md:grid-cols-3 gap-8 items-center" data-id="element-204">
          {/* Text Content */}
          <div className="md:col-span-2 space-y-6" data-id="element-205">
            <h2 className="text-2xl md:text-4xl font-bold text-white leading-tight" data-id="element-206">
              While influencers burn out chasing views...
              <span className="text-accent-green" data-id="element-207">
                {' '}
                "Invisible Asset Managers"
              </span>{' '}
              quietly collect
              <span className="text-accent-cyan" data-id="element-208"> $5,000 – $30,000/month</span>
            </h2>

            <p className="text-lg text-text-muted leading-relaxed" data-id="element-209">
              They don't film themselves. They don't edit for hours. They don't
              even own a camera. Instead, they've discovered a system that turns
              AI into a content machine—building faceless YouTube channels that
              generate income while they sleep.
            </p>

            <div className="flex flex-wrap gap-4" data-id="element-210">
              <div className="flex items-center gap-2 text-accent-green" data-id="element-211">
                <EyeOffIcon className="w-5 h-5" data-id="element-212" />
                <span className="font-semibold" data-id="element-213">Zero Face Time</span>
              </div>
              <div className="flex items-center gap-2 text-accent-cyan" data-id="element-214">
                <DollarSignIcon className="w-5 h-5" data-id="element-215" />
                <span className="font-semibold" data-id="element-216">Predictable Revenue</span>
              </div>
            </div>
          </div>

          {/* Visual Element */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={isInView ? {
          opacity: 1,
          scale: 1
        } : {}} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="relative" data-id="element-217">
            <div className="glass-card rounded-2xl p-6 text-center" data-id="element-218">
              <div className="text-5xl md:text-6xl font-black text-accent-green mb-2" data-id="element-219">
                $30K
              </div>
              <div className="text-text-muted text-sm uppercase tracking-wide" data-id="element-220">
                Monthly Potential
              </div>
              <div className="mt-4 h-px bg-gradient-to-r from-transparent via-border-subtle to-transparent" data-id="element-221" />
              <div className="mt-4 text-text-light text-sm" data-id="element-222">
                Without showing your face
              </div>
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}